import React, { useState } from "react";
import { Box, LabelStyled } from "../../ui/Elements";
import { Form, FormGroup } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ValidationErrorText from "./ValidationErrorText";

const ValidatedInput = ({
  name,
  type,
  fieldType,
  placeholder,
  label,
  value,
  register,
  validationRules,
  className,
  disabled,
  errors,
  staric,
  classNameLabel,
  errorDisplay,
  errorMessage = "",
  maxLength,
  ref,
  ...rest
}) => {
  const { t } = useTranslation();
  const [showType, setType] = useState(fieldType);
  

  const inputStyles = type === "textarea" ? { height: "130px" } : {};

  return (
    <ValidatedInputWrapper className={className} {...rest}>
      <FormGroup controlId={name} className="formEleContainer">
        {label && (
          <LabelStyled
            className={classNameLabel}
            
          >
            {t(label)}
            {staric && <span className="staric">*</span>}
          </LabelStyled>
        )}
        <Box className="position-relative w-100">
          <Form.Control
            as={type}
            type={showType}
            value={value}
            disabled={disabled}
            placeholder={t(placeholder)}
            style={inputStyles}
            maxLength={maxLength}
            ref={ref}
            {...(register && register(name, validationRules))}
          />
          

          {errors && (
            <>
              {errors[name]?.type === "required" && (
                <ValidationErrorText
                
                  text={
                    t(errors[name]?.message) ||
                    `${t(label || name)} ${t("isRequired")}.`
                  }
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "minLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "maxLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "pattern" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  extraClass={errorDisplay}
                />
              )}
              {errors[name]?.type === "validate" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  extraClass={errorDisplay}
                />
              )}
            </>
          )}
        </Box>
      </FormGroup>
    </ValidatedInputWrapper>
  );
};

export default ValidatedInput;

export const ValidatedInputWrapper = styled.div`
  width: 100%;
  /* padding: 9px 25px 9px 25px; */
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  .formEleContainer {
    display: flex;
    flex-wrap: wrap;
    padding: 7px 0px 0px 0px;
    margin: 0px 0 0px 0;
    align-items: center;
    gap: 5px;
    
    /* & > label {
      min-width: 160px;
      body.rtl & {
        font-family: var(--arRegular);
      }

      &.w-auto {
        min-width: auto;
      }
    }
    &.inp-white {
      input {
        background-color: var(--white);
      }
    } */
  }
  /* &.combined {
    border-bottom: none;
    padding: 8px 25px 8px 25px;
    &:last-child{
            border-bottom: 1px solid var(--borderLight);
        }
    .formEleContainer {
      display: flex;
      padding: 0;
      margin: 0;
    }
  } */
  &.flex-wrap {
    .formEleContainer {
      flex-wrap: wrap;
      label {
        width: 100%;
      }
    }
  }
  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
    background-color: var(--white);
  }

  .form-control {
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 6px;
    border: 1px solid var(--border);
    background-color: ${({ bg }) => (bg ? bg : "var(--white)")};
    padding-left: 15px;
    padding-right: 15px;
    &::placeholder {
      color: var(--textPlaceholder2);
    }
    body.rtl &{
      font-family: var(--arRegular);
    }

  }
  .form-control:focus {
    box-shadow: none;
    outline: none;
    border: 1px solid var(--border);
  }
  @media (max-width: 767px) {
    /* .formEleContainer {
      flex-wrap: wrap;
      gap: 3px;
      margin: 0;
      padding: 3px 0px 3px 0px;
      label {
        width: 100%;
      }
    } */
  }
`;
